import { render, staticRenderFns } from "./ThreeDSecure.vue?vue&type=template&id=2d80e95e"
import script from "./ThreeDSecure.vue?vue&type=script&lang=js"
export * from "./ThreeDSecure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports